import React from "react";
import { observer } from "mobx-react";
import "../styles/SidePage.less";
import SubscriptionEditPage from "~/modules/BillingCentral/app/SubscriptionEditPage";

const ClientPanelSubscriptionEditPage = observer(props => <SubscriptionEditPage {...props} />);

export default ClientPanelSubscriptionEditPage;
